/**
 * Customer 模块 - 枚举定义
 * 
 * @description
 * 本文件包含 Customer 模块的所有枚举类型，用于确保前后端枚举值的一致性。
 * 
 * @module Types/Customer/Enums
 * 
 * @backend-mapping
 * - 客户类型（CustomerType）→ backend/app/Modules/Sales/Models/Customer.php::TYPE_*
 * - 信用等级（CreditLevel）→ backend/app/Modules/Sales/Models/Customer.php::CREDIT_*
 * - 状态（CustomerStatus）→ backend/app/Modules/Sales/Models/Customer.php::STATUS_*
 * 
 * @update-trigger
 * - Model 新增或修改常量时
 * - 业务需求变更枚举值时
 * 
 * @validation-method
 * - 对照 Model 的常量定义
 * - 确保枚举值和类型完全匹配
 * 
 * @author YSFL Team
 * @last-updated 2025-10-19
 */

/**
 * 客户类型枚举
 * @backend Customer::TYPE_*
 */
export enum CustomerType {
  /** 直接客户 */
  DIRECT = 1,
  /** 代理商 */
  AGENT = 2,
  /** OEM */
  OEM = 3,
}

/**
 * 信用等级枚举
 * @backend Customer::CREDIT_*
 */
export enum CreditLevel {
  /** 优 */
  EXCELLENT = 1,
  /** 良 */
  GOOD = 2,
  /** 中 */
  AVERAGE = 3,
  /** 差 */
  POOR = 4,
  /** 黑名单 */
  BLACKLIST = 5,
}

/**
 * 客户状态枚举
 * @backend Customer::STATUS_*
 */
export enum CustomerStatus {
  /** 停用 */
  INACTIVE = 0,
  /** 正常 */
  ACTIVE = 1,
}

